import { gallery } from "../../data/gallery";

export default function Gallery() {
  return (
    <div>
      <h2 className="heading">Gallery</h2>
      <div className="subheading">
        Click on an image to find out more about my endevours.
      </div>
      <div className="gallery">
        {gallery.map((img, index) => (
          <div className="card" key={index}>
            <a href={img.link} className="link">
              <img src={img.src} alt={img.caption} />
              <div className="caption-container">
                <div className="caption">{img.caption}</div>
              </div>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
